/** Espelha status_conferencia (db_compras): situação de uma ação da conferência física (volumes ou itens). */
export enum StatusConferenciaEnum {
  EmAndamento = 1,
  Concluida = 2,
}
